<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 7,
    }"
    :wrapper-col="{
      span: 13,
    }"
  >
    <a-form-item label="角色">
      <a-select
        v-model:value="formState.roles"
        :options="rolesList"
        mode="multiple"
        placeholder="点击绑定角色"
      ></a-select>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import { reactive, ref, defineProps, defineEmits, onMounted } from 'vue'
  import { message } from 'ant-design-vue'
  import { getUserRole, userBindRole } from '@/api/system_manage/userManage'
  import { getRole } from '@/api/system_manage/role'

  const props = defineProps({ editData: Object })
  const emit = defineEmits(['submit'])
  const formRef = ref()
  const rolesList = ref([])

  const defaultFormState = props.isEdit
    ? {
        roles: props.editData.roles,
      }
    : {
        roles: [],
      }
  const formState = reactive(defaultFormState)
  const rules = {}
  async function handelBind(data) {
    const res = await userBindRole(data)
    if (res.success) {
      message.success('绑定角色成功！')
      emit('submit')
    } else {
      message.warn('绑定角色错误：', res.message)
    }
  }
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelBind({
          userId: props.editData.user_id,
          roleIds: formState.roles.toString(),
          roleId: formState.roles.toString(),
        })
      })
      .catch((error) => {
        console.log('绑定角色错误：', error)
      })
  }
  function resetForm() {
    formRef.value.resetFields()
  }
  function fetch() {
    getRole().then((res) => {
      if (res.success) {
        rolesList.value = res.data.map((role) => ({
          value: role.role_id,
          label: role.name,
        }))
      }
    })
    getUserRole({ userId: props.editData.user_id }).then((res) => {
      if (res.success) {
        formState.roles = res.data.map((role) => role.role_id)
      }
    })
  }
  onMounted(() => {
    fetch()
  })
</script>
